import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import Card from "../card";
import "./style.scss";
import { generateReactKey } from "../../utils/reactKey";

const MixedContentGridItems = ({ items }) => {
  const chunkArray = (a, chunkSize) => {
    let result = [];
    for (let i = 0; i < a.length; i += chunkSize)
      result.push(a.slice(i, i + chunkSize));
    return result;
  };

  let i = 0;
  const chunkedItems = chunkArray(items, 3);

  const gridLayout = items => {
    let j = 0;
    const cardsCount = items.filter(item => item).length,
      className = classNames("subgrid", "subgrid--one-row", {
        "subgrid--one-card": cardsCount === 1,
        "subgrid--two-cards": cardsCount === 2
      });
    return (
      <div className={className} key={generateReactKey()}>
        {items
          .filter(item => item)
          .map(item => {
            item.cardSize = ["small", "small", "mixed"][j];
            item.cardAspect = ["portrait", "portrait", "portrait"][j];
            item.cardGridArea = ["a", "b", "c"][j++];
            return (
              <Card {...item} key={item?.cardContent.heading + i + "-" + j} />
            );
          })}
      </div>
    );
  };

  const largeCardLeftLayout = items => {
    let j = 0;
    const cardsCount = items.filter(item => item).length,
      className = classNames("subgrid", "subgrid--large-left", {
        "subgrid--one-card": cardsCount === 1,
        "subgrid--two-cards": cardsCount === 2
      });
    return (
      <div className={className} key={generateReactKey()}>
        {items
          .filter(item => item)
          .map(item => {
            item.cardSize = ["small", "small", "large"][j];
            item.cardAspect = ["portrait", "portrait", "portrait"][j];
            item.cardGridArea = ["a", "b", "c"][j++];

            return (
              <Card {...item} key={item.cardContent.heading + i + "-" + j} />
            );
          })}
      </div>
    );
  };

  const largeCardRightLayout = items => {
    let j = 0;
    const cardsCount = items.filter(item => item).length,
      className = classNames("subgrid", "subgrid--large-right", {
        "subgrid--one-card": cardsCount === 1,
        "subgrid--two-cards": cardsCount === 2
      });
    return (
      <div className={className} key={generateReactKey()}>
        {items
          .filter(item => item)
          .map(item => {
            item.cardSize = ["small", "small", "large"][j];
            item.cardAspect = ["portrait", "portrait", "portrait"][j];
            item.cardGridArea = ["a", "b", "c"][j++];
            return (
              <Card {...item} key={item?.cardContent.heading + i + "-" + j} />
            );
          })}
      </div>
    );
  };

  const landscapeCardLayout = items => {
    let j = 0;
    const cardsCount = items.filter(item => item).length,
      className = classNames("subgrid", "subgrid--landscape", {
        "subgrid--one-card": cardsCount === 1,
        "subgrid--two-cards": cardsCount === 2
      });
    return (
      <div className={className} key={generateReactKey()}>
        {items
          .filter(item => item)
          .map(item => {
            item.cardSize = ["small", "small", "large"][j];
            item.cardAspect = ["landscape", "landscape", "landscape"][j];
            item.cardGridArea = ["a", "b", "c"][j++];

            return (
              <Card {...item} key={item?.cardContent.heading + i + "-" + j} />
            );
          })}
      </div>
    );
  };

  const mixedLayout = items => {
    const row = i++ % 4;

    if (items.length === 3) {
      if (row === 1) {
        return landscapeCardLayout(items);
      } else if (row === 2) {
        return largeCardRightLayout(items);
      } else if (row === 3) {
        return largeCardLeftLayout(items);
      }
    }
    return gridLayout(items);
  };

  return chunkedItems.map(items.length < 9 ? gridLayout : mixedLayout);
};

export default MixedContentGridItems;

MixedContentGridItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
};
